<template>
    <a-modal :open="open" @update:open="(val) => emit('update:open', val)" :title="modalTitle" @ok="handleSubmit"
        @cancel="handleCancel" :confirmLoading="loading" width="700px">
        <a-form :model="formState" ref="formRef" :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }">

            <!-- 主体名称展示 -->
            <a-form-item label="主体名称">
                <a-tag color="blue" style="font-size: 14px; padding: 4px 12px;">
                    {{ props.record?.full_name || '未知主体' }}
                </a-tag>
            </a-form-item>

            <a-form-item label="手机号码" name="xftel" required>
                <div style="display: flex; gap: 8px;">
                    <a-input v-model:value="formState.xftel" placeholder="请输入续费联系人手机号码" style="flex: 1;"
                        @change="onXftelChange" />
                    <a-button :disabled="state.mobileBlurLoading" :loading="state.mobileBlurLoading"
                        @click="contactMobileBlur" type="primary">
                        查询({{ state.filingsList.length }})
                    </a-button>
                </div>
                <!-- 查询结果标签 -->
                <div class="mt-1x" v-if="state.filingsList.length > 0">
                    <a-tag v-for="(item, index) in state.filingsList" :key="index" class="mr-1x mb-1x pointer"
                        :color="item.status === 1 ? 'success' : 'error'" @click="selectFilingsListChange(item)">
                        {{ item.company_name }}
                    </a-tag>
                </div>
            </a-form-item>

            <a-form-item label="续费联系人身份" required>
                <a-radio-group v-model:value="formState.xftel_type" button-style="solid">
                    <a-radio-button :value="1">个人</a-radio-button>
                    <a-radio-button :value="2">公司</a-radio-button>
                </a-radio-group>
            </a-form-item>

            <a-form-item label="在续费联系人处代账" required>
                <a-radio-group v-model:value="formState.xftel_daizhang" button-style="solid">
                    <a-radio-button :value="1">是</a-radio-button>
                    <a-radio-button :value="2">否</a-radio-button>
                </a-radio-group>
            </a-form-item>

            <a-form-item :label="formState.xftel_type === 2 ? '续费联系人公司名称' : '续费联系人姓名'" required>
                <a-input v-model:value="formState.finance_company_name"
                    :placeholder="formState.xftel_type === 2 ? '请输入续费联系人公司名称' : '请输入续费联系人姓名'" />
            </a-form-item>

            <a-form-item :label="formState.xftel_type === 2 ? '统一社会信用代码' : '身份证号码'"
                :required="formState.xftel_type === 2">
                <a-input v-model:value="formState.finance_social_credit_code"
                    :placeholder="formState.xftel_type === 2 ? '请输入统一社会信用代码' : '请输入身份证号码'" />
            </a-form-item>

            <a-form-item label="对接人姓名" required>
                <a-input v-model:value="formState.finance_contact_name" placeholder="请输入对接人姓名" />
            </a-form-item>

            <a-form-item label="对接人微信号">
                <a-input v-model:value="formState.finance_contact_wechat_account" placeholder="请输入对接人微信号" />
            </a-form-item>

            <a-form-item label="对接人微信昵称">
                <a-input v-model:value="formState.finance_contact_wechat_nickname" placeholder="请输入对接人微信昵称" />
            </a-form-item>

            <a-form-item label="对接人其他号码">
                <a-input v-model:value="formState.finance_contact_phone" placeholder="请输入对接人其他号码" />
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script lang="ts" setup>
import { ref, reactive, watch, computed } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { mobileRequiredValidator } from '@/utils/util'

const props = defineProps<{
    open: boolean
    record: any
}>()

const emit = defineEmits<{
    (e: 'update:open', value: boolean): void
    (e: 'success'): void
}>()

const loading = ref(false)
const formRef = ref()

// 动态标题
const modalTitle = computed(() => {
    const name = props.record?.full_name || '未知主体'
    return `修改「${name}」的续费联系人信息`
})

// 状态管理
const state = reactive({
    mobileBlurLoading: false,
    filingsList: [] as any[],
})

const formState = reactive({
    xftel: '',
    xftel_type: 1,
    xftel_daizhang: 2,
    finance_company_name: '',
    finance_social_credit_code: '',
    finance_contact_name: '',
    finance_contact_wechat_account: '',
    finance_contact_wechat_nickname: '',
    finance_contact_phone: '',
})

// 监听弹窗打开，初始化数据
watch(
    () => props.open,
    (val) => {
        if (val && props.record) {
            Object.assign(formState, {
                xftel: props.record.xftel || '',
                xftel_type: props.record.xftel_type || 1,
                xftel_daizhang: props.record.xftel_daizhang || 2,
                finance_company_name: props.record.finance_company_name || '',
                finance_social_credit_code: props.record.finance_social_credit_code || '',
                finance_contact_name: props.record.finance_contact_name || '',
                finance_contact_wechat_account: props.record.finance_contact_wechat_account || '',
                finance_contact_wechat_nickname: props.record.finance_contact_wechat_nickname || '',
                finance_contact_phone: props.record.finance_contact_phone || '',
            })
            // 重置查询列表
            state.filingsList = []
        }
    },
    { immediate: true }
)

// 手机号变化时，清空之前的查询结果
const onXftelChange = () => {
    state.filingsList = []
}

// 查询续费联系人信息
const contactMobileBlur = () => {
    if (state.mobileBlurLoading) {
        return
    }

    // 验证手机号
    if (!formState.xftel || !/^1[23456789]\d{9}$/.test(formState.xftel)) {
        message.warning('请先填写正确的手机号码')
        return
    }

    state.mobileBlurLoading = true
    let requestParam = {
        url: '/admin/v1/filingsList',
        method: 'post',
        data: {
            page: 1,
            limit: 'all',
            customer_tel: formState.xftel
        }
    }

    baseService(requestParam)
        .then((res: any) => {
            state.mobileBlurLoading = false
            const list = res?.data?.list || []

            if (list.length === 0) {
                message.warning('该手机号码没有绑定财务公司，请手动填写')
                state.filingsList = []
                return
            }

            // 过滤出已通过审核的公司（status === 1）
            const validList = list.filter((item: any) => item.status === 1)

            if (validList.length === 0) {
                message.warning('该手机号码绑定的财务公司暂未通过审核，请联系管理员')
                state.filingsList = list // 显示所有，但颜色会区分
                return
            }

            state.filingsList = list

            // 如果只有一条记录，自动填充
            if (validList.length === 1) {
                const item = validList[0]
                autoFillData(item)
                message.success('已自动填充续费联系人信息')
            } else if (validList.length > 1) {
                message.info('找到多条记录，请点击选择需要填充的公司')
            }
        })
        .catch((res) => {
            state.mobileBlurLoading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('查询失败，请稍后重试')
            }
        })
}

// 选择列表中的公司进行填充
const selectFilingsListChange = (item: any) => {
    if (item.status !== 1) {
        message.warning('该公司暂未通过审核，无法填充')
        return
    }
    autoFillData(item)
    message.success('已填充续费联系人信息')
}

// 自动填充数据
const autoFillData = (item: any) => {
    formState.finance_company_name = item.company_name || ''
    formState.finance_social_credit_code = item.finance_social_credit_code || ''
    formState.finance_contact_name = item.customer_name || ''
    formState.finance_contact_wechat_account = item.wechat_id || ''
    formState.finance_contact_wechat_nickname = item.wechat_name || ''
    // 其他号码不自动填充，因为可能包含多个号码，需要手动确认
}

const handleSubmit = async () => {
    // 验证手机号
    try {
        await mobileRequiredValidator({}, formState.xftel)
    } catch (err) {
        message.error(err as string)
        return
    }

    // 验证姓名/公司名称
    if (!formState.finance_company_name?.trim()) {
        message.error(formState.xftel_type === 2 ? '请输入续费联系人公司名称' : '请输入续费联系人姓名')
        return
    }

    // 如果是公司类型，验证统一社会信用代码
    if (formState.xftel_type === 2 && !formState.finance_social_credit_code?.trim()) {
        message.error('请输入统一社会信用代码')
        return
    }

    // 验证对接人姓名
    if (!formState.finance_contact_name?.trim()) {
        message.error('请输入对接人姓名')
        return
    }

    loading.value = true
    try {
        const res = await baseService({
            url: '/admin/v1/quickChangeXftelInfo',
            method: 'post',
            data: {
                customer_id: props.record.id,
                xftel: formState.xftel,
                xftel_type: formState.xftel_type,
                xftel_daizhang: formState.xftel_daizhang,
                finance_company_name: formState.finance_company_name,
                finance_social_credit_code: formState.finance_social_credit_code,
                finance_contact_name: formState.finance_contact_name,
                finance_contact_wechat_account: formState.finance_contact_wechat_account,
                finance_contact_wechat_nickname: formState.finance_contact_wechat_nickname,
                finance_contact_phone: formState.finance_contact_phone,
            }
        })
        message.success(res.msg || '修改成功')
        emit('success')
        emit('update:open', false)
    } catch (err: any) {
        message.error(err?.msg || '修改失败，请稍后重试')
    } finally {
        loading.value = false
    }
}

const handleCancel = () => {
    emit('update:open', false)
}
</script>

<style scoped>
.mt-1x {
    margin-top: 8px;
}

.mr-1x {
    margin-right: 8px;
}

.mb-1x {
    margin-bottom: 8px;
}

.pointer {
    cursor: pointer;
}
</style>
